import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Anexos } from '../../models/anexos.model';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { ActivatedRoute } from '@angular/router';
import { AnexosService } from '../../services/anexos.service';
import { AnexosResolver } from '../../resolver/anexos.resolver';
import { NavigationService } from 'src/app/modules/projeto-completo/services/navigation.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-anexos-list',
  templateUrl: './anexos-list.component.html',
  styleUrls: ['./anexos-list.component.scss']
})
export class AnexosListComponent extends BaseFormComponent<Anexos> implements OnInit {

  id:number;
  currentAttachId:number;
  data: Anexos;
  modalRef?: BsModalRef;

  @ViewChild('modal') modal: TemplateRef<any>;
  
  constructor(
    public activatedRoute: ActivatedRoute,
    public myService: AnexosService,
    public anexosResolver: AnexosResolver,
    private modalService: BsModalService,
    private navigation: NavigationService
  ) { 
    super(activatedRoute);
  }

  ngOnInit() {
    this.loading();
    this.activatedRoute.parent.paramMap.subscribe(params => {
      this.id = +params.get('id');
    });
    this.start();
  }
  start(){
    if(this.id && this.id != 0){
      this.anexosResolver.getAll( this.id ).subscribe({
        next: (data) => {
          var newData = data;
          this.entity = newData;
          this.data = newData;
          this.loaded();
        },
        error: (error) => {
          this.loaded();
          this.msgError(error.error.message);
        }
      })
    }
    else{
      this.loaded();
    }
  }

  download(attachId:number, fileName:string): void {
    this.loading();
    this.myService.downloadFile(attachId).subscribe({
      next: (res) => {
        this.downloadFile(res, fileName);
      },
      error: (error) => {
        console.error('Erro ao baixar o arquivo:', error);
        this.loaded();
        this.msgError(error?.error.message);
      },
    });
  }

  downloadFile(res, fileName:string) {
    const blob = new Blob([res.body], { type: 'application/octet-stream' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    link.click();
    window.URL.revokeObjectURL(url);
    this.loaded();
  }

  confirmExcluir(attachId:number) {
    this.alertConfirmation().subscribe((confirmed) => {
      if (confirmed) {
        this.excluir(attachId);
      }
    });
  }
  excluir(attachId:number): void {
    this.loading();
    this.myService.delete(attachId).subscribe({
      next: (res) => {
        this.confirmation('Deletado com sucesso').subscribe(() => {
          window.location.reload();
        });
      },
      error: (error) => {
        this.loaded();
        this.msgError(error?.error.message)
      }
    });
  }
  
  voltar() {
    this.navigation.back([`reuniao/reunioes`]);
  }
  
  openModal(attachId:number) {
    this.currentAttachId = attachId;
    this.modalRef = this.modalService.show(this.modal,{class:"modal-m"});
  }

  closeModal() {
    this.modalRef?.hide();
  }

}
